import { Stack, Typography } from '@mui/material';
import React from 'react';
import './Features.scss';
import Feature from './feature/Feature';

function Features() {
  return (
    <div>
      <div style={{ marginBottom: '10px' }}>
        <Typography variant="h6" fontWeight="bold">
          Features:
        </Typography>
      </div>
      <Stack spacing={1}>
        <Feature>625 Hymns & Songs</Feature>
        <Feature>Simple, elegant styling</Feature>
        <Feature>Traditional southern-style harmony</Feature>
        <Feature>Recovery of many rich, original lyrics</Feature>
        <Feature>6X9 format provides easy to read music and lyrics</Feature>
        <Feature>
          Organized by subject and content categoriesScripture index
        </Feature>
        <Feature>Scripture index</Feature>
        <Feature>
          Cross-referencing for alternate tunes and arrangements
        </Feature>
      </Stack>
    </div>
  );
}

export default Features;
